export default __webpack_public_path__ + "static/media/icon_folder.b02a6e20.svg";